/**
 * Navigation Store Default State
 * Initial values for all navigation state properties
 */

import type { NavigationState } from './types'

export const defaultValues: NavigationState = {
  path: [],
  pathString: '',
  expandedItems: [],
  expandedItemsString: '',
  openAccordions: [],
  openAccordionsString: '',
  pathChangedByNavigation: false,
}
